module.exports = __webpack_public_path__ + "img/Luna-Vista.734305e2.jpeg";